class checkBillDetailCtrl {
    constructor($scope, httpRequest, $state, $stateParams) {
        // 如果是控制台则增加样式
        if ($state.current.name.indexOf('workspace') > -1) {
            $scope.haveBorder = true
        }
        // 隐藏一二级菜单
        $('#wrapper').addClass('invoiceDetailPage')
        $scope.$on('$stateChangeStart', () => {
            $('#wrapper').removeClass('invoiceDetailPage')
        })
        const {
            billId,
            kdAccountId
        } = $stateParams.obj ? JSON.parse($stateParams.obj) : $stateParams //isCollect=true为数据采集详情， 否则常规详情
        const dicArr = ['inv_type', 'invoice_nature', 'invoice_nature', 'bill_status', 'tax_includ', 'is_privilege', 'zero_tax', 'yes_no_flag', 'invoice_status', 'is_list']
        // $scope.currentPage1 = 1
        // $scope.maxSize1 = 5
        // $scope.currentPage2 = 1
        // $scope.maxSize3 = 5
        $scope.billInfo = {}
        $scope.qryBillDetail = {}
        $scope.qryBillInvoice = {}
        $scope.param1 = {
            pageNum : 1,
            pageSize: 5,
        }
        $scope.param2 = {
            pageNum : 1,
            pageSize: 5,
        }
        httpRequest.get_dictByTypeArr(dicArr).then((res) => {
            $scope.dictData = res.data.value
        })

        $scope.getInfo = function (qryAPI, param) { //获取详情
            httpRequest[qryAPI](param).then((res) => {
                $scope.billInfo = res.data.value
                if ($scope.billInfo.invoiceType == '41') {
                    httpRequest.post_getSysRollticketSpecList({
                        pageNum: 1,
                        pageSize: 10000,
                        param: {},
                    }).then((response) => {
                        if (response.data.success) {
                            $scope.billInfo.rollticketCode = response.data.value.list.filter((item) => item.rollticketCode == JSON.parse($scope.billInfo.extendInfo).rollticketCode)[0].specification
                        }
                    })
                }
                if (kdAccountId) {
                    $scope.qryBillDetail.list = $scope.billInfo.billDetailList
                }
            })
        }

        if (kdAccountId) {
            $scope.isCollect = true
            $scope.getInfo('get_getBillDetailByBillId', {
                billId,
                kdAccountId
            })
        } else {
            $scope.getInfo('get_qryBillInfo', billId)
        }

        // 分页获取商品明细列表
        const qryBillDetailList = function () {
            $scope.param1.param = billId
            httpRequest.post_qryBillDetailList($scope.param1).then((res) => {
                $scope.qryBillDetail.list = res.data.value.list
                $scope.param1.total = res.data.value.total
                // $scope.totalItems1 = res.data.value.total
                // $scope.currentPage1 = ++res.data.value.prePage
                // $scope.maxSize1 = res.data.value.pageSize
            })
        }
        // 分页获取发票详情列表 post_qryBillInvoice
        const qryBillInvoice = function () {
            $scope.param2.param = billId
            httpRequest.post_qryBillInvoice($scope.param2).then((res) => {
                $scope.qryBillInvoice.list = res.data.value.list
                $scope.param2.total = res.data.value.total
                // $scope.totalItems2 = res.data.value.total
                // $scope.currentPage2 = ++res.data.value.prePage
                // $scope.maxSize2 = res.data.value.pageSize
            })
        }
        if (!kdAccountId) {
            qryBillDetailList()
            qryBillInvoice()
        }

        $scope.pageChanged1 = function () {
            qryBillDetailList()
        }
        $scope.pageChanged2 = function () {
            qryBillInvoice()
        }

        $scope.toInvoiceDetail = function toInvoiceDetail(item) {
            if (!item.invoiceId) return
            let url = ''
            if (item.invType == 12) {
                url = 'outputManage.FOManage.ovatBill.relatedVehicleDetail'
            } else if (item.invType == 41) {
                url = 'outputManage.FOManage.ovatBill.relatedRollDetail'
            } else {
                url = 'outputManage.FOManage.ovatBill.relatedInvoiceDetail'
            }
            window.open($state.href(url, {
                invoiceId: item.invoiceId,
            }, {
                reload: true,
            }), '_blank')
        }
    }
}
checkBillDetailCtrl.$inject = ['$scope', 'httpRequest', '$state', '$stateParams']
export default checkBillDetailCtrl


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/checkBillDetailCtrl.js